import { useCallback, useEffect } from "react";

import type { FreshworksCommand } from "../types/freshworks";

const FRESHWORKS_WIDGET_ID = 72000002430;

let isLoaded = false;

export function useFreshworksWidget(email: string, username: string) {
  const loadFreshworks = useCallback(() => {
    if (isLoaded) return;

    const script = document.createElement("script");
    script.src = `https://widget.freshworks.com/widgets/${FRESHWORKS_WIDGET_ID}.js`;

    document.body.append(script);
    isLoaded = true;
  }, []);

  useEffect(() => {
    if (typeof window.FreshworksWidget !== "function") {
      loadFreshworks();
      window.FreshworksWidget = Object.assign(
        function (...args: FreshworksCommand) {
          loadFreshworks();
          window.FreshworksWidget.q.push(args);
        },
        { q: [] as FreshworksCommand[] },
      );
    }

    window.fwSettings = { widget_id: FRESHWORKS_WIDGET_ID };
  }, [loadFreshworks]);

  const open = useCallback(() => {
    window.FreshworksWidget("open");
  }, []);

  useEffect(() => {
    if (isLoaded) {
      window.FreshworksWidget("identify", "ticketForm", {
        name: username,
        email,
      });
      window.FreshworksWidget("hide", "launcher");
    }
  }, [email, username]);

  return { isLoaded, open };
}
